<template>
    <section class="stealth-queued-flow-item">
        <div class="grid-container">
            <div class="profile-label">
                Queued flow item
            </div>
        </div>
        <template lang="html">
            <div class="table-scroller">
                <ds-table-grid
                    :data="queuedFlowItemList"
                    align="center"
                    data-qa="queued-flow-item-table"
                >
                    <ds-table-grid-column
                        label="Id"
                        width="90"
                        data-qa="queued-id"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.id }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Flow item id"
                        width="110"
                        data-qa="queued-flow-item-id"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span :title="queuedFlowItem.flowItemId">
                                {{ queuedFlowItem.flowItemId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Flow recipient id"
                        width="130"
                        data-qa="queued-flow-recipient-id"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.flowRecipientId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Run date"
                        width="170"
                        data-qa="queued-run-date"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.runDate }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Processed date"
                        width="170"
                        data-qa="queued-processed-date"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.processedDate }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Status"
                        width="110"
                        data-qa="queued-status"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.status }}
                            </span>
                        </template>
                    </ds-table-grid-column>


                    <ds-table-grid-column
                        label="Reaper message"
                        width="200"
                        data-qa="queued-reaper-message"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.reaperMessage }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Thread id"
                        width="90"
                        data-qa="queued-thread-id"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span :title="queuedFlowItem.threadId">
                                {{ queuedFlowItem.threadId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Dependency id"
                        width="110"
                        data-qa="queued-dependency-id"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.dependencyId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Retry"
                        width="110"
                        data-qa="queued-retry"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.retry }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Num retry"
                        width="90"
                        data-qa="queued-num-retry"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.numRetry }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="type"
                        width="110"
                        data-qa="queued-type"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.type }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Date created"
                        width="170"
                        data-qa="queued-date-created"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.dateCreated }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Last updated"
                        width="170"
                        data-qa="queued-last-updated"
                    >
                        <template slot-scope="queuedFlowItem">
                            <span>
                                {{ queuedFlowItem.lastUpdated }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>
            <div v-if="!noResultsToDisplay">
                <p class="no-details-label">
                    No results to display
                </p>
            </div>
        </template>
    </section>
</template>

<script>
export default {
    props: {
        queuedFlowItemList: Array,
    },

    computed: {
        noResultsToDisplay() {
            return this.queuedFlowItemList?.length > 0;
        },
    },
};
</script>
<style lang="scss" scoped>
    .grid-container {
        margin: $spacing-250 0;
        display: flex;
    }

    .profile-label {
        margin: auto;
        font-size: 1.75rem;
        color: $color-text;
    }

    .table-scroller {
        overflow:auto;
        white-space: nowrap;
    }

    @media only screen and ($medium) {
        .grid-container {
            margin-top: 1.875rem;
            display: block;
        }
    }

    .stealth-queued-flow-item {
        display: grid;
    }

    .no-details-label {
        color: $color-gray-darker;
        font-size: $font-size-lg;
        font-weight: 300;
        padding-top: $spacing-400;
    }
</style>
